import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { NotificationBell } from "@/components/NotificationBell";
import { LogOut } from "lucide-react";

export default function DashboardLayout({ nav, children, title }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:flex w-64 bg-white border-r border-slate-200 flex-col" data-testid="dashboard-sidebar">
        <div className="p-6 border-b border-slate-200">
          <Link to="/"><Logo /></Link>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((item) => {
            const active = location.hash === `#${item.key}` || (location.hash === "" && item.key === nav[0].key);
            return (
              <a key={item.key} href={`#${item.key}`}
                 data-testid={`sidebar-${item.key}`}
                 className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ${active ? "bg-[#155EEF] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
                <item.icon size={18} />
                {item.label}
              </a>
            );
          })}
        </nav>
        <div className="p-4 border-t border-slate-200">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-heading font-bold" style={{ background: user?.avatar_color || "#155EEF" }}>
              {user?.name?.[0]?.toUpperCase()}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{user?.name}</div>
              <div className="text-xs text-slate-500 truncate">{user?.email}</div>
            </div>
          </div>
          <button onClick={handleLogout} data-testid="logout-btn" className="w-full flex items-center gap-2 text-sm text-slate-600 hover:text-brand px-3 py-2 rounded-lg hover:bg-slate-100">
            <LogOut size={16} /> Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <header className="sticky top-0 z-40 glass-nav">
          <div className="px-6 lg:px-10 h-16 flex items-center justify-between">
            <div>
              <div className="eyebrow">{user?.role}</div>
              <h1 className="font-heading font-bold text-xl">{title}</h1>
            </div>
            <div className="flex items-center gap-4">
              <NotificationBell />
              <div className="lg:hidden">
                <button onClick={handleLogout} className="text-sm text-slate-600" data-testid="mobile-logout">Log out</button>
              </div>
            </div>
          </div>
        </header>
        <div className="p-6 lg:p-10 max-w-7xl mx-auto">{children}</div>
      </main>
    </div>
  );
}
